import { ADD_SEARCH_BAR_VERTICALIZED_DYNAMIC_TEXT_241115 } from "@faire/web-api--source/indigofair/settings/ADD_SEARCH_BAR_VERTICALIZED_DYNAMIC_TEXT_241115";

import { useSetting, useAssignSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export const useSettingAddSearchBarVerticalizedDynamicText = () =>
  useSetting(ADD_SEARCH_BAR_VERTICALIZED_DYNAMIC_TEXT_241115, false);

export const useAssignSettingAddSearchBarVerticalizedDynamicText = () =>
  useAssignSetting(ADD_SEARCH_BAR_VERTICALIZED_DYNAMIC_TEXT_241115);
